var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { isSameDay } from 'date-fns';
import { addMonth, composeEventHandlers, isBackDisabled, isForwardDisabled, subtractMonth, } from './utils';
export function getDateProps({ onDateSelected, handleKeyDown, manageFocus, onBlured, onFocused, date, }, _a) {
    var { onClick, onKeyDown, onBlur, onFocus, dateObj } = _a, rest = __rest(_a, ["onClick", "onKeyDown", "onBlur", "onFocus", "dateObj"]);
    const dateProps = Object.assign({ onClick: composeEventHandlers([
            onClick,
            (event) => {
                onDateSelected(dateObj, event);
            },
        ]), disabled: !dateObj.selectable, 'aria-label': dateObj.date.toDateString(), 'aria-pressed': dateObj.selected, role: 'button', 'data-calendar-day': dateObj.date.getDate(), tabIndex: isSameDay(dateObj.date, date) ? 0 : -1, autoFocus: isSameDay(dateObj.date, date) }, rest);
    if (manageFocus) {
        dateProps.onKeyDown = composeEventHandlers([onKeyDown, handleKeyDown]);
        dateProps.onBlur = composeEventHandlers([onBlur, onBlured]);
        dateProps.onFocus = composeEventHandlers([onFocus, onFocused]);
    }
    return dateProps;
}
export function getBackProps({ minDate, offsetMonth, handleOffsetChanged, }, _a) {
    var { onClick, offset = 1, calendars } = _a, rest = __rest(_a, ["onClick", "offset", "calendars"]);
    return Object.assign({ onClick: composeEventHandlers([
            onClick,
            () => {
                handleOffsetChanged(offsetMonth - subtractMonth({ calendars, offset, minDate }));
            },
        ]), disabled: isBackDisabled({ calendars, minDate }), 'aria-label': `Go back ${offset} month${offset === 1 ? '' : 's'}` }, rest);
}
export function getForwardProps({ maxDate, offsetMonth, handleOffsetChanged, }, _a) {
    var { onClick, offset = 1, calendars } = _a, rest = __rest(_a, ["onClick", "offset", "calendars"]);
    return Object.assign({ onClick: composeEventHandlers([
            onClick,
            () => {
                handleOffsetChanged(offsetMonth + addMonth({ calendars, offset, maxDate }));
            },
        ]), disabled: isForwardDisabled({ calendars, maxDate }), 'aria-label': `Go forward ${offset} month${offset === 1 ? '' : 's'}` }, rest);
}
